import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ProductCatalogVisibilityBadges from "./ProductCatalogVisibilityBadges";

const formatEur = (n) => {
  if (n == null || Number.isNaN(Number(n))) return "--";
  return `${Number(n).toFixed(2)}€`;
};

const CardProdotto = ({ product, onOpenDetail }) => {
  const disponibile = (product.disponibilita ?? 0) > 0;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        gap: { xs: 2, sm: 0 },
        px: 2,
        py: 1.5,
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        border: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "0 1px 3px rgba(15, 23, 42, 0.06)",
        "&:hover": {
          boxShadow: "0 4px 12px rgba(15, 23, 42, 0.12)",
          transform: "translateY(-1px)",
        },
        transition: "all 0.18s ease-out",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          minWidth: 0,
          flex: "1 1 auto",
          justifyContent: "flex-start",
        }}
      >
        <Box
          component="img"
          src={
            product.linkImmagine ||
            product.linkImmagine1 ||
            product.linkImmagine2 ||
            "https://placehold.co/200?text=Nessuna%5CnImmagine&font=rubik"
          }
          alt={product.nome}
          sx={{
            width: 72,
            height: 72,
            borderRadius: "10px",
            objectFit: "cover",
            flexShrink: 0,
          }}
        />
        <Typography
          sx={{
            minWidth: 0,
            fontFamily: "Rubik",
            fontWeight: "bold",
            color: "#0b3d87",
            fontSize: 15,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
          title={product.nome}
        >
          {product.nome}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: { xs: "flex-start", sm: "flex-end" },
          alignItems: "center",
          columnGap: { xs: 2, sm: 2.5 },
          rowGap: 1.5,
          marginLeft: { sm: 3 },
          flexShrink: 0,
        }}
      >
        <ProductCatalogVisibilityBadges product={product} />

        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
          <Typography sx={{ fontFamily: "Rubik", color: "#808080", fontSize: 12 }}>Prezzo</Typography>
          <Typography sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87", fontSize: 16 }}>
            {formatEur(product.prezzoVendita)}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
          <Typography sx={{ fontFamily: "Rubik", color: "#808080", fontSize: 12 }}>Spedizione</Typography>
          <Typography sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87", fontSize: 16 }}>
            {formatEur(product.speseDiSpedizione)}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
          <Typography sx={{ fontFamily: "Rubik", color: "#808080", fontSize: 11 }}>Disponibilità</Typography>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: disponibile ? "#2e7d32" : "#e00036",
              mt: 0.2,
            }}
          />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={onOpenDetail}
            sx={{
              fontFamily: "Rubik",
              textTransform: "none",
              borderRadius: "999px",
              fontWeight: "bold",
              backgroundColor: "#0b3d87",
              px: 2.5,
              py: 0.5,
              fontSize: 13,
              "&:hover": { backgroundColor: "#092b6a" },
              whiteSpace: "nowrap",
            }}
          >
            Dettagli
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CardProdotto;
